// import { fetchNurserySettings } from "@parent-app/services";
// import { ChildrenStoreData } from "@parent-app/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { nurserySettingAction } from "./NurserySlice";
import { ChildrenStoreData } from "src/shared/types/src";
import { fetchNurserySettings } from "src/shared/services/src";


export const getNurserySettings = createAsyncThunk(
    "getNurserySettings", async ({ child }: { child: ChildrenStoreData }, { dispatch }) => {
        try {
            // console.log("childRec", child)
            if (!child?.systemsEnabled?.eylog && !child?.systemAccess?.eylog) {
                await dispatch(nurserySettingAction.resetNurserySettings());
                return Promise.resolve();
            }
            dispatch(nurserySettingAction.setSettingsLoading(true));
            const response = await fetchNurserySettings({ child });

            if (response && Object.keys(response).length > 0) {
                console.log("Nursery Settings : ", response);
                await dispatch(nurserySettingAction.setSettingsData(response.settings));
            }
        } catch (error) {
            console.log("Error fetching nursery settings: ", error);
        } finally {
            dispatch(nurserySettingAction.setSettingsLoading(false));
        }
    }
)